// extracted by mini-css-extract-plugin
export default {"verticalNavbar":"Footer_verticalNavbar__SWpp1","iconVerticalNavbar":"Footer_iconVerticalNavbar__HOLeA"};